import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button, ButtonGroup } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';

import { FIELDS } from './new';
import { UPDATE_BANK_ACCOUNT } from './queries';

const EditBankAccount = ({ bankAccount, setShowModal, refetch }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource: bankAccount })
  });

  const [updateBankAccount] = useMutation(UPDATE_BANK_ACCOUNT, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    input['ownerType'] = bankAccount.ownerType;
    input['ownerId'] = bankAccount.ownerId;
    setFormStatus('submitting');
    updateBankAccount({ variables: prepareInput(input, FIELDS) });
  });

  const fields = { ...FIELDS };

  return (
    <View>
      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />

      <ButtonGroup>
        <Button label="Update Bank Account" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default EditBankAccount;
